export class CodingDisplay {
    element: string;
    value: string;
}
